import React from 'react';

import { AccountCard } from '@app/common/components/AccountCard';

import styles from './styles.pcss';

export interface AccountsDropDownOptionsProps {
  readonly className?: string
  readonly icon?: React.ReactElement
  readonly onClick: () => void
  readonly title: string
}

export const AccountsDropDownOption: React.FC<AccountsDropDownOptionsProps> = ({
  className,
  icon,
  onClick,
  title,
}) => (
  <button
    className={styles.item}
    onClick={() => { onClick(); }}
    tabIndex={-1}
    type="button"
  >
    <AccountCard
      title={title}
      titleBefore={icon}
      className={className}
    />
  </button>
);
